import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	optionsLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.dropdown.options-label',
		defaultMessage: 'Options',
		description:
			'Header for configuring field options of a single select field (e.g. dropdown, radio, etc.)',
	},
});
